// deps
import React from "react";

// constants
import { LOADER_TYPE } from "@payment-client/constants/Loader";

interface HalfCardLoaderProps {
    title: string;
    loaderBgSrc: string;
}

interface HalfCardLoaderData {
    type: LOADER_TYPE.HALF_CARD;
    halfCardLoaderProps?: HalfCardLoaderProps;
}

interface OtherLoaderData {
    type: LOADER_TYPE.FULL_PAGE | LOADER_TYPE.MOVING_TRAY;
}

export type PaymentLoaderData = HalfCardLoaderData | OtherLoaderData;

export interface PaymentLoaderContextValue {
    isLoading: boolean;
    loaderData: PaymentLoaderData;
    setLoaderState: (isLoading: boolean, data?: PaymentLoaderData) => void;
}

export const PaymentLoaderContext = React.createContext<PaymentLoaderContextValue>({
    isLoading: false,
    loaderData: {
        type: LOADER_TYPE.MOVING_TRAY,
    },
    setLoaderState: () => void 0,
});

if (__DEV__) {
    PaymentLoaderContext.displayName = "PaymentLoaderContext";
}
